import React, { ReactElement } from "react";
import { IconProps } from "./types";

export const PaypalNewIcon = ({
  width = "31",
  height = "32",
}: IconProps): ReactElement => {
  return (
    <div data-testid="PayPal_Icon">
      <svg
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_9262_13948)">
          <path
            d="M28.9372 8.2675C29.0023 7.8275 29.036 7.37875 29.036 6.92375C29.036 3.1 25.3242 0 20.7458 0H6.89095C6.01912 0 5.27527 0.525625 5.13084 1.24312L0.0256245 26.5856C-0.15772 27.495 0.681923 28.3237 1.78573 28.3237H6.85278C7.7246 28.3237 8.48268 27.7987 8.62711 27.0806C8.62711 27.0806 8.63534 27.0387 8.65105 26.9625L7.94462 30.4681C7.78297 31.2694 8.52309 32 9.49594 32H13.9291C14.6969 32 15.3532 31.5369 15.4805 30.9037L16.7399 24.6525C16.9569 23.575 18.0742 22.7856 19.3823 22.7856H20.5468C26.8725 22.7856 32.0002 18.5031 32.0002 13.22C32.0002 11.1756 30.7901 9.36875 28.9372 8.2675Z"
            fill="#002987"
          />
          <path
            d="M28.937 8.26758C28.1445 13.6538 22.6479 17.8245 15.9839 17.8245H12.1172C11.2446 17.8245 10.4911 18.3101 10.2546 18.9963L7.94369 30.4682C7.78204 31.2695 8.52216 32.0001 9.49501 32.0001H13.9282C14.696 32.0001 15.3523 31.537 15.4795 30.9038L16.739 24.6526C16.956 23.5751 18.0733 22.7857 19.3814 22.7857H20.5458C26.8716 22.7857 31.9993 18.5032 31.9993 13.2201C31.9993 11.1757 30.7892 9.36883 28.9363 8.26758H28.937Z"
            fill="#0085CC"
          />
          <path
            d="M12.118 17.8244H15.9847C22.6479 17.8244 28.1445 13.6538 28.9378 8.26755C27.7486 7.56067 26.2961 7.1438 24.7253 7.1438H14.6331C13.4844 7.1438 12.5034 7.83692 12.3125 8.78317L10.2553 18.9963C10.4918 18.31 11.2454 17.8244 12.118 17.8244Z"
            fill="#00186A"
          />
        </g>
        <defs>
          <clipPath id="clip0_9262_13948">
            <rect width="32" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
